import React from "react";
import { Grid2 } from "@mui/material";
import PageTitle from "../../../components/Common/PageTitle/index";
import LinkBox from "../../../components/Content/LinkBox";

import {
  PAGE_TITLE,
  PAGE_TEXT,
  VIDEO_URL,
  LINK_BOX_TITLE,
  LINK_BOX_URL,
  SECTION_TITLE,
  GUEST_EMAIL,
  GUEST_EMAIL_LABEL,
} from "./Podcasts.constants";
import {
  RootBox,
  ContentGrid,
  ContentRow,
  ContentColumn,
  SectionTitle,
  EmailLink,
  PodcastImage,
  LinkBoxWrapper,
} from "./Podcasts.styles";

const podcastImage = require("../../../assets/images/podcast.png");

const Podcasts = () => {
  const handleEmailClick = () => window.open(GUEST_EMAIL, "_blank");

  return (
    <RootBox>
      <ContentGrid container spacing={2}>
        <Grid2 item size={{ xs: 12 }}>
          <PageTitle
            title={PAGE_TITLE}
            text={PAGE_TEXT}
            noIcon
            videoUrl={VIDEO_URL}
          />
        </Grid2>
        <Grid2 item size={{ xs: 12 }}>
          <ContentRow>
            <ContentColumn>
              <PodcastImage src={podcastImage} alt="podcast" />
              <LinkBoxWrapper>
                <LinkBox title={LINK_BOX_TITLE} link={LINK_BOX_URL} />
              </LinkBoxWrapper>

              <SectionTitle>{SECTION_TITLE}</SectionTitle>
              <EmailLink onClick={handleEmailClick}>
                {GUEST_EMAIL_LABEL}
              </EmailLink>
            </ContentColumn>
          </ContentRow>
        </Grid2>
      </ContentGrid>
    </RootBox>
  );
};

export default Podcasts;
